// extracted by mini-css-extract-plugin
export var tag = "styles-module--tag--87cf1";
export var tags = "styles-module--tags--b1b05";
export var tagsContainer = "styles-module--tagsContainer--fc713";